export function createWaterMark(source, text) {
  return new Promise(resolve => {
    let img = new Image()
    img.src = source
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      var scale = Math.max(img.width / 200, img.height / 400)
      // if (scale < 1) {
      //   scale = 1
      // }
      let canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      let watermarkText = '轻秒图片转换器'
      // let fontSize = canvas.width / 20; // 设置水印字体大小
      let fontSize = scale * 14
      ctx.font = fontSize + 'px Arial'
      ctx.fillStyle = 'rgba(255,255,255,0.4)' // 设置水印颜色和透明度

      //--------------
      // let textWidth = ctx.measureText(watermarkText).width;
      // // 计算水印位置
      // let x = canvas.width - textWidth - fontSize;
      // let y = canvas.height - fontSize;
      // // 绘制水印
      // ctx.fillText(watermarkText, x, y);
      // -------------

      // for (var x = 0; x < canvas.width; x += 20) {
      //     for (var y = 0; y < canvas.height; y += 20) {
      //         ctx.fillText(watermarkText, x, y);
      //     }
      // }
      // --------------------

      // var textWidth = ctx.measureText(watermarkText).width;
      // var spacingX = textWidth * 2; // 根据文字宽度计算水印之间的水平间距
      //
      // for (var x = 0; x < canvas.width; x += spacingX) {
      //     for (var y = 0; y < canvas.height; y += spacingX / 2) {
      //         ctx.fillText(watermarkText, x, y);
      //     }
      // }
      // -----------
      // 根据图片宽高比例调整字体大小和水印间距

      var textWidth = ctx.measureText(watermarkText).width
      var spacingX = textWidth * 2 // 根据文字宽度计算水印之间的水平间距

      for (var x = 0; x < canvas.width; x += spacingX / 1.2) {
        for (var y = 0; y < canvas.height; y += spacingX / 1.5) {
          ctx.save() // 保存当前绘图状态
          ctx.translate(x + textWidth / 2, y + fontSize / 2) // 平移到水印中心点
          // var angle = Math.random() * Math.PI / 4 - Math.PI / 8; // 随机生成旋转角度，范围为 -π/8 到 π/8
          ctx.rotate(120) // 旋转
          ctx.fillText(watermarkText, -textWidth / 2, fontSize / 2) // 绘制水印
          ctx.restore() // 恢复到上一个保存的绘图状态
        }
      }

      console.log(canvas.toDataURL())
      let src = canvas?.toDataURL()
      resolve(src)
      // resolve(canvas.toDataURL('image/jpeg'))
    }
  })
}
